// extracted by mini-css-extract-plugin
module.exports = {"wrapperMap":"_2aWMZ","storeInfo":"_2kdki","infoTitle":"_3pX8i","titleContact":"CmaUp","content":"_2efkH","image":"_2cusR","grid":"_2U5ZU","timetable":"_1Kht_","map":"mLwFn"};